import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Paper Cthulhu",
  "description": "",
  "published": "2007-04-01T00:00:00.000Z",
  "redirect_from": ["/blog/paper-cthulhu/swizec/247"],
  "categories": "intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A `}{`[link]`}{`(`}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=ACP/submode=ACP_news/%5C"
      }}>{`http://swizec.com/index.php/mode=ACP/submode=ACP_news/\\`}</a>{`) has been given me through MSN. A very interesting `}{`[link]`}{`(`}<a parentName="p" {...{
        "href": "http://swizec.com/index.php/mode=ACP/submode=ACP_news/%5C"
      }}>{`http://swizec.com/index.php/mode=ACP/submode=ACP_news/\\`}</a>{`) at that. It supposedly guards the secret to making a Cthulhu out of paper complete with cutouts and vague instructions, just like you'd want. The only problem is that the images aren't high resolution so the outcome isn't looking too rosey.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      